module.exports = function parseBNtoString(num, digit=18) {
  let str = num+'';
  let strList = str.split('.');
  let xs = strList[1] ? strList[1].length : 0;
  if (xs > digit) {
    return null
  }
  let netNum = str.replace('.', '')
  return netNum+Array.from({length: digit - xs}).reduce((preVal, curVal) => {
    return preVal + '0'
  }, '')
}
